import { Key, Mail, MessageCircleMore } from "lucide-react"
import { Button } from "shared-web/components/base/control/Button"

import { useAppSelector } from "app/hooks"

import { selectLocationWithoutDefault } from "./authSlice"
import { useSignInContext } from "./SignInContext"
import { SignInLocationCombobox } from "./SignInLocationCombobox"
import {
  StepCard,
  StepCardBody,
  StepCardFooter,
  StepCardTitle,
} from "./StepCard"

type StepKeyProps = {
  onClickScanKey: () => void
}

export function StepKey(props: StepKeyProps) {
  const { onClickScanKey } = props

  const selectedLocation = useAppSelector(selectLocationWithoutDefault)

  const { setStep } = useSignInContext()

  return (
    <StepCard>
      <StepCardTitle>Sign in to Rundoo</StepCardTitle>
      <StepCardBody>
        <SignInLocationCombobox />
      </StepCardBody>
      <StepCardFooter>
        <fieldset
          disabled={!selectedLocation}
          className="flex flex-col gap-y-4"
        >
          <Button
            mode="secondary"
            leftIcon={MessageCircleMore}
            onClick={() => setStep("text-message")}
          >
            Sign in using text message
          </Button>
          <Button
            mode="secondary"
            leftIcon={Mail}
            onClick={() => setStep("email")}
          >
            Sign in using email
          </Button>
          <Button mode="secondary" leftIcon={Key} onClick={onClickScanKey}>
            Sign in using key
          </Button>
        </fieldset>
      </StepCardFooter>
    </StepCard>
  )
}
